import React, { Component } from "react";

import styled from "styled-components";
import {
  Card,
  CardBody,
  CardText,
  Col,
  Container,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import classnames from "classnames";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Settings from "./Settings";
import Offers from "./Offers/index";
import Rent from "./Rent/index";
import Dashboard from "./Dashboard/index";
// import Activity from "./Activity/index";
// import Credentials from "./Credentials/index";
import PropTypes from "prop-types";
import {
  deleteApp,
  getAppById,
  setAppClear,
  patchAppStatus,
  patchApp,
  setApp,
  setAppDataNull,
  addAppById,
} from "../../../store/apps/actions";
import { getUsersToList, setUsersToList } from "../../../store/user/user-list/actions";
import { getOffersForClient, setOffersForClient } from "../../../store/offers/actions";
import { connect } from "react-redux";
import {
  getClientById,
  patchClient,
  setErrorClient,
  deleteClient,
} from "../../../store/clients/actions";
import {
  getBankUploading,
  updateBankUploading,
  deleteBankUploading,
} from "../../../store/bank-uploading/actions";
import { getTrackerPlatforms } from "../../../store/meta/actions";
import DynamicModalWithInput from "../../../components/DynamicModalWithInput/DynamicModalWithInput";
// import Payments from "./Payments";
import { getTransactionsChart } from "../../../store/transactions/actions";
import { getContractorProfile } from "../../../store/contractors/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class ClientInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "",
      deleteModalActive: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const client_id = this.props.match.params.clientId;
    this.setState({ userId: client_id });
    this.props.getTrackerPlatforms();
    this.props.getUsersToList({
      sizePerPage: 0,
      is_active: true
    })
    this.props.getTransactionsChart({
      contractor: [5],
    });
    // this.props.getContractorProfile(5);
    if (!this.props.location.state?.was_created) {
      this.props.getClientById(client_id);
    } else {
      this.props.history.replace({ state: { was_created: false } });
    }

    this.handleUpdateTab();

    this.props.permissions["view_clientapplicationmodel"] &&
      this.props.getAppById(client_id);
  }

  handleUpdateTab = () => {
    const hash = this.props.location.hash.split("#").join("") || "offers";
    this.toggle(hash);
  };

  componentDidUpdate(prevProps, props) {
    if (prevProps.location.hash !== this.props.location.hash) {
      this.handleUpdateTab();
    }
  }

  componentWillUnmount() {
    this.props.setErrorClient(false);
    this.props.setUsersToList({ results: []})
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  onActiveDeleteModal = () => {
    const { deleteModalActive } = this.state;
    this.setState({ deleteModalActive: !deleteModalActive });
  };

  onDelete = () => {
    const { deleteModalActive } = this.state;
    this.setState({ deleteModalActive: !deleteModalActive });
    this.props.deleteClient(this.props.match.params.clientId);
    this.props.history.push(`/clients`);
  };

  handleGetFilteredUsers = () => {
    let filteredUsers = []
    this.props.users.results.map(i => {
      if (i.positions_list !== 'Admin' && i.positions_list !== 'CEO') {
        filteredUsers.push({
          label: `${i.first_name} ${i.last_name}`,
          value: i.id,
        })
      }
    })
    return filteredUsers;
  }

  render() {
    const {
      client,
      apps,
      addAppById,
      patchClient,
      isError,
      getOffersForClient,
      setOffersForClient,
      offers,
      rentOffers,
    } = this.props;

    if (isError) {
      return <Redirect to={"/404"} />;
    }

    return (
      <React.Fragment>
        {client && (
          <div className="page-content">
            <ModifiedMetaTags title={`${client?.legal_name || 'Client'} | Mobihunter`} />

            <Container fluid>
              <Breadcrumbs
                title="Clients"
                breadcrumbItem={
                  this.props.client_loading ? "" : client.legal_name
                }
                link="/clients"
              />

              <DynamicModalWithInput
                isOpen={this.state.deleteModalActive}
                toggle={this.onActiveDeleteModal}
                action={this.onDelete}
                header={client?.legal_name}
                what="delete"
                alertColor="danger"
                alertText="Deleting a offer permanently removes the offer content. The
              profile, trackers, media buyer budgets, media buyer plans and
              offer history."
              />

              <Row>
                <Col sm="col-12">
                  <Card className="mb-0">
                    <CardBody>
                      <Nav
                        tabs
                        className="nav-tabs-custom"
                        style={{
                          width: "80%",
                          borderBottom: "0",
                        }}
                      >
                        <NavItem className="d-none">
                          <Link
                            style={{ cursor: "pointer" }}
                            to={{ hash: "" }}
                            className={classnames("nav-link", {
                              active: this.state.activeTab === "activity",
                            })}
                            onClick={() => {
                              this.toggle("activity");
                            }}
                          >
                            Activity
                          </Link>
                        </NavItem>
                        <NavItem>
                          <Link
                            style={{ cursor: "pointer" }}
                            to={{ hash: "offers" }}
                            className={classnames("nav-link", {
                              active: this.state.activeTab === "offers",
                            })}
                            onClick={() => {
                              this.toggle("offers");
                            }}
                          >
                            Offers
                          </Link>
                        </NavItem>
                        {/* TODO: Will change when backend be done */}
                        <NavItem>
                          <Link
                            style={{ cursor: "pointer" }}
                            to={{ hash: "rent_offers" }}
                            className={classnames("nav-link", {
                              active: this.state.activeTab === "rent_offers",
                            })}
                            onClick={() => {
                              this.toggle("rent_offers");
                            }}
                          >
                            Rent offers
                          </Link>
                        </NavItem>
                        {/* <NavItem>
                          <Link
                            style={{ cursor: "pointer" }}
                            to={{ hash: "payments" }}
                            className={classnames("nav-link", {
                              active: this.state.activeTab === "payments",
                            })}
                            onClick={() => {
                              this.toggle("payments");
                            }}
                          >
                            Payments
                          </Link>
                        </NavItem> */}
                        {/* <NavItem>
                          <Link
                            style={{ cursor: "pointer" }}
                            to={{ hash: "credentials" }}
                            className={classnames("nav-link", {
                              active: this.state.activeTab === "credentials",
                            })}
                            onClick={() => {
                              this.toggle("credentials");
                            }}
                          >
                            Credentials
                          </Link>
                        </NavItem> */}
                        <NavItem>
                          <Link
                            style={{ cursor: "pointer" }}
                            to={{ hash: "settings" }}
                            className={classnames("nav-link", {
                              active: this.state.activeTab === "settings",
                            })}
                            onClick={() => {
                              this.toggle("settings");
                            }}
                          >
                            Settings
                          </Link>
                        </NavItem>
                        <NavItem>
                          <Link
                            style={{ cursor: "pointer" }}
                            to={{ hash: "dashboard" }}
                            className={classnames("nav-link", {
                              active: this.state.activeTab === "dashboard",
                            })}
                            onClick={() => {
                              this.toggle("dashboard");
                            }}
                          >
                            Dashboard
                          </Link>
                        </NavItem>
                      </Nav>
                      <div
                        style={{
                          position: "absolute",
                          right: "20px",
                          top: "26%",
                        }}
                      >
                        {this.props.permissions["delete_clientmodel"] && (
                          <UncontrolledDropdown>
                            <DropdownToggle className="card-drop" tag="a">
                              <ActionsBtn type="button">Actions</ActionsBtn>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                              <DropdownItem
                                onClick={() => this.onActiveDeleteModal()}
                                className="align-middle center align-content-center"
                              >
                                <i className="mdi mdi-trash-can font-size-16 text-danger me-1 align-middle" />{" "}
                                Delete client
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>

            <TabContent
              activeTab={this.state.activeTab}
              className="text-muted"
              style={{ padding: "40px 12px 0px 12px" }}
            >
              <TabPane tabId="activity">
                <Card>
                  <CardBody>
                    <Row>
                      <Col sm="12">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu
                        fugiat nulla pariatur. Excepteur sint occaecat cupidatat
                        non proident, sunt in culpa qui officia deserunt mollit
                        anim id est laborum.
                        {/* <Activity /> */}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </TabPane>
              <TabPane tabId="offers">
                <Card>
                  <CardBody>
                    <Row>
                      <Col sm="12">
                        {this.state.activeTab == "offers" && (
                          <Offers
                            permissions={this.props.permissions}
                            getOffers={getOffersForClient}
                            setOffers={setOffersForClient}
                            offers={offers}
                            clientId={this.props.match.params.clientId}
                            loading_offer_data={this.props.loading_offer_data}
                            rent={false}
                          />
                        )}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </TabPane>
              <TabPane tabId="rent_offers">
                <Card>
                  <CardBody>
                    <Row>
                      <Col sm="12">
                        {this.state.activeTab == "rent_offers" && (
                          <Rent
                            permissions={this.props.permissions}
                            getOffers={getOffersForClient}
                            setOffers={setOffersForClient}
                            offers={rentOffers}
                            clientId={this.props.match.params.clientId}
                            loading_offer_data={this.props.loading_offer_data}
                            rent
                          />
                        )}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </TabPane>
              <TabPane tabId="dashboard">
                <Row>
                  <Col sm="12">
                    <Dashboard
                      getTransactionsChart={this.props.getTransactionsChart}
                      data={this.props.transactionChart}
                      contractor={this.props.profileData}
                    />
                  </Col>
                </Row>
              </TabPane>
              {/* <TabPane tabId="payments">
                <Card>
                  <CardBody>
                    <Row>
                      <Col sm="12">
                        <Payments
                          data={this.props.bank_uploading}
                          history={this.props.history}
                          permissions={this.props.permissions}
                          clientId={this.props.match.params.clientId}
                          getBankUploading={this.props.getBankUploading}
                          updateBankUploading={this.props.updateBankUploading}
                          deleteBankUploading={this.props.deleteBankUploading}
                          loading={this.props.bank_uploading_loader}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </TabPane> */}
              {/* <TabPane tabId="credentials">
                <Card>
                  <CardBody>
                    <Row>
                      <Col sm="12">
                        <Credentials />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </TabPane> */}
              <TabPane tabId="settings">
                <Row>
                  <Col sm="12">
                    <Settings
                      client={client}
                      apps={apps}
                      apps_loading={this.props.apps_loading}
                      getAppsById={this.props.getAppById}
                      addAppById={addAppById}
                      patchClient={patchClient}
                      userId={this.state.userId}
                      history={this.props.history}
                      deleteApp={this.props.deleteApp}
                      permissions={this.props.permissions}
                      tracking_platforms={this.props.tracking_platforms}
                      patchAppStatus={this.props.patchAppStatus}
                      patchApp={this.props.patchApp}
                      setApp={this.props.setApp}
                      setAppDataNull={this.props.setAppDataNull}
                      users={this.handleGetFilteredUsers()}
                    />
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const ActionsBtn = styled.div`
  color: hsl(0, 0%, 70%);
  user-select: none;
  padding: 7.5px 12px;
  border: 1.5px solid hsl(0, 0%, 70%);
  border-radius: 5px;
  transition-duration: 0.5s;

  &:hover {
    transition-duration: 0.5s;
    color: hsl(0, 0%, 55%);
    border: 1.5px solid hsl(0, 0%, 55%);
  }
`;

ClientInfo.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      clientId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  client: PropTypes.any,
  offers: PropTypes.any,
  apps: PropTypes.any,
  apps_loading: PropTypes.bool,
  profileData: PropTypes.any,
  transactionsChart: PropTypes.any,
  bank_uploading: PropTypes.object.isRequired,
  bank_uploading_loader: PropTypes.bool.isRequired,
  getClientById: PropTypes.func,
  getAppById: PropTypes.func,
  setAppClear: PropTypes.func,
  patchClient: PropTypes.func,
  getOffersForClient: PropTypes.func,
  setOffersForClient: PropTypes.func,
  setErrorClient: PropTypes.func,
  addAppById: PropTypes.func,
  deleteApp: PropTypes.func,
  deleteClient: PropTypes.func,
  history: PropTypes.any,
  isError: PropTypes.bool,
  location: PropTypes.object,
  loading_offer_data: PropTypes.bool,
  client_loading: PropTypes.bool,
  permissions: PropTypes.any,
  tracking_platforms: PropTypes.any,
  getBankUploading: PropTypes.func,
  updateBankUploading: PropTypes.func,
  deleteBankUploading: PropTypes.func,
  getTrackerPlatforms: PropTypes.func,
  patchAppStatus: PropTypes.func,
  patchApp: PropTypes.func,
  setApp: PropTypes.func,
  setAppDataNull: PropTypes.func,
  getTransactionsChart: PropTypes.func,
  getContractorProfile: PropTypes.func,
  transactionChart: PropTypes.any,
  rentOffers: PropTypes.any,
  getUsersToList: PropTypes.func,
  setUsersToList: PropTypes.func,
  users: PropTypes.any,
};

const mapStateToProps = state => ({
  offers: state.Offers.dataClient,
  rentOffers: state.Offers.dataRentOffers,
  loading_offer_data: state.Offers.loading_offer_data,
  apps: state.Apps.apps,
  apps_loading: state.Apps.loading,
  bank_uploading: state.BankUploading.data,
  bank_uploading_loader: state.BankUploading.loading,
  isError: state.Clients.isError,
  client: state.Clients.client,
  client_loading: state.Clients.client_loading,
  permissions: state.User.permissions,
  history: PropTypes.any,
  tracking_platforms: state.Meta.tracking_platforms,
  transactionChart: state.transactions.transactionChart,
  profileData: state.ContractorList.profileData,
  users: state.UsersList.data,
});
export default connect(mapStateToProps, {
  getClientById,
  getAppById,
  setAppClear,
  patchClient,
  getOffersForClient,
  setOffersForClient,
  setErrorClient,
  addAppById,
  deleteApp,
  deleteClient,
  getBankUploading,
  updateBankUploading,
  deleteBankUploading,
  getTrackerPlatforms,
  patchAppStatus,
  patchApp,
  setApp,
  setAppDataNull,
  getTransactionsChart,
  getContractorProfile,
  getUsersToList,
  setUsersToList
})(withRouter(ClientInfo));